import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@freelancer/components';
import {
  DatastoreServiceOfferingsModule,
  DatastoreSiteStatsModule,
} from '@freelancer/datastore/collections';
import { FeatureFlagsModule } from '@freelancer/feature-flags';
import { PipesModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import {
  GalleryMosaicComponent,
  GalleryMosaicInteractiveContentComponent,
} from '@freelancer/ui/gallery-mosaic';
import { AiServicesComponent } from 'app/back-to-work/ai-services/ai-services.component';
import { CompaniesTrustModule } from 'app/companies-trust/companies-trust.module';
import { InvitationRedirectAlertModule } from 'app/invitation-redirect/invitation-redirect-alert/invitation-redirect-alert.module';
import { LandingPageShowcaseCardModule } from 'app/landing-page-showcase-card/landing-page-showcase-card.module';
import { LandingPageSharedModule } from 'app/seo-sem/landing-page-shared.module';
import { HomePageAiServicesComponent } from './ai-services/ai-services.component';
import { HomePageApiEnterpriseBladeComponent } from './api-enterprise/api-enterprise-blade.component';
import { HomePageApiUpsellCardComponent } from './api-enterprise/api-upsell-card.component';
import { HomePageEnterpriseUpsellCardComponent } from './api-enterprise/enterprise-upsell-card.component';
import { HomePageApiEnterpriseRedesignComponent } from './api-enterprise-redesign/api-enterprise-redesign.component';
import { HomePageApiEnterpriseCardComponent } from './api-enterprise-v3/api-enterprise-card.component';
import { HomePageApiEnterpriseV3Component } from './api-enterprise-v3/api-enterprise-v3.component';
import { HomePageApiEnterpriseSectionComponent } from './api-enterprise-v4/api-enterprise-section/api-enterprise-section.component';
import { HomePageApiEnterpriseV5Component } from './api-enterprise-v4/api-enterprise-v5.component';
import { HomePageCompaniesTrustComponent } from './companies-trust/companies-trust.component';
import { CrowdFavoritesCarouselComponent } from './crowd-favorites-redesign/crowd-favorite-carousel/crowd-favorites-carousel.component';
import { CrowdFavoriteCarouselItemComponent } from './crowd-favorites-redesign/crowd-favorite-carousel-item/crowd-favorite-carousel-item.component';
import { HomePageCrowdFavoriteLoadingStateComponent } from './crowd-favorites-redesign/crowd-favorite-loading-state.component';
import { HomePageCrowdFavoritesRedesignComponent } from './crowd-favorites-redesign/crowd-favorites-redesign.component';
import { HomePageDiscoverSectionComponent } from './discover-section/discover-section.component';
import { HomePageGlobalTalentComponent } from './global-talent/global-talent.component';
import { HomePageHeroComponent } from './hero/home-page-hero.component';
import { HomePageHireCategoriesComponent } from './hire-categories/hire-categories.component';
import { HomePageHireCategoryItemComponent } from './hire-categories/hire-category-item.component';
import { HomePageMetaWrapperComponent } from './home-page-meta-wrapper.component';
import { HomePageRoutingModule } from './home-page-routing.module';
import { HomePageComponent } from './home-page.component';
import { HomePageJobCategoriesLoadingComponent } from './job-categories/job-categories-loading.component';
import { HomePageJobCategoriesComponent } from './job-categories/job-categories.component';
import { HomePageJobCategoryItemComponent } from './job-categories/job-category-item.component';
import { HomePageJobCategoriesRedesignComponent } from './job-categories-redesign/job-categories-redesign.component';
import { HomePageApiEnterpriseLoadingStateComponent } from './loading-state/api-enterprise/api-enterprise-loading-state.component';
import { HomePageBenefitsLoadingStateComponent } from './loading-state/benefits/benefits-loading-state.component';
import { HomePageCompaniesTrustLoadingStateComponent } from './loading-state/companies-trust/companies-trust-loading-state.component';
import { HomePageHireCategoriesLoadingStateComponent } from './loading-state/hire-categories/hire-categories-loading-state.component';
import { HomePageNeedWorkDoneLoadingStateComponent } from './loading-state/need-work-done/need-work-done-loading-state.component';
import { HomePageMakeItRealComponent } from './make-it-real/make-it-real.component';

@NgModule({
  imports: [
    AiServicesComponent,
    CommonModule,
    CompaniesTrustModule,
    DatastoreSiteStatsModule,
    DatastoreServiceOfferingsModule,
    FeatureFlagsModule,
    GalleryMosaicComponent,
    GalleryMosaicInteractiveContentComponent,
    HomePageRoutingModule,
    InvitationRedirectAlertModule,
    LandingPageSharedModule,
    LandingPageShowcaseCardModule,
    PipesModule,
    TrackingModule,
    UiModule,
    ComponentsModule,
  ],
  exports: [HomePageMetaWrapperComponent, CrowdFavoriteCarouselItemComponent],
  declarations: [
    CrowdFavoriteCarouselItemComponent,
    CrowdFavoritesCarouselComponent,
    HomePageApiEnterpriseBladeComponent,
    HomePageApiEnterpriseRedesignComponent,
    HomePageApiEnterpriseCardComponent,
    HomePageApiEnterpriseLoadingStateComponent,
    HomePageApiEnterpriseV3Component,
    HomePageApiEnterpriseV5Component,
    HomePageApiEnterpriseSectionComponent,
    HomePageApiUpsellCardComponent,
    HomePageBenefitsLoadingStateComponent,
    HomePageCompaniesTrustComponent,
    HomePageCompaniesTrustLoadingStateComponent,
    HomePageComponent,
    HomePageCrowdFavoriteLoadingStateComponent,
    HomePageCrowdFavoritesRedesignComponent,
    HomePageEnterpriseUpsellCardComponent,
    HomePageHeroComponent,
    HomePageHireCategoriesComponent,
    HomePageHireCategoryItemComponent,
    HomePageHireCategoriesLoadingStateComponent,
    HomePageJobCategoriesComponent,
    HomePageJobCategoriesLoadingComponent,
    HomePageJobCategoriesRedesignComponent,
    HomePageJobCategoryItemComponent,
    HomePageMetaWrapperComponent,
    HomePageNeedWorkDoneLoadingStateComponent,
    HomePageMakeItRealComponent,
    HomePageDiscoverSectionComponent,
    HomePageGlobalTalentComponent,
    HomePageAiServicesComponent,
  ],
})
export class HomePageModule {}
